import { useScrollReveal } from '@/hooks/useScrollReveal';

const members = [
  {
    name: 'Rina Takei',
    role: 'CEO',
    description: 'カプコンやコンサルなど複数社を経てChammiを創業。日本アニメ、漫画、RPGが好き。',
    image:
      'https://storage.readdy-site.link/project_files/777ff6c9-ee60-489f-b76a-eca20a2d3e36/4c8c8a6f-1d55-4491-a307-5f681c840bbc_-2026-04-01-21.34.29.png?v=24609941d74b22ca8463b844aa7b3b12',
    mono: false,
  },
  {
    name: 'Takahiro Kono',
    role: '',
    description: '複数のスタートアップで新規事業を立ち上げ。Chammiではビジネス周りやクリエイター組織作りなどを担当。',
    image:
      'https://storage.readdy-site.link/project_files/777ff6c9-ee60-489f-b76a-eca20a2d3e36/59df5fed-55d4-4515-81ef-a352cc758a58_-2026-04-01-21.34.36.png?v=60d12f00cfe9c254eb8b708669dad72b',
    mono: true,
  },
  {
    name: '他にも・・・',
    role: '',
    description: 'AIクリエイター・海外起業経験のあるITエンジニア・映画制作現場のベテランなどの仲間がいます。',
    image:
      'https://storage.readdy-site.link/project_files/777ff6c9-ee60-489f-b76a-eca20a2d3e36/9db71dd8-69da-4956-a790-4f8f6bbb8e35_-2026-04-01-21.34.44.png',
    mono: false,
  },
];

export default function TeamSection() {
  const { ref: headRef, isVisible: headVisible } = useScrollReveal<HTMLDivElement>();
  const { ref: gridRef, isVisible: gridVisible } = useScrollReveal<HTMLDivElement>();

  return (
    <section className="py-24 md:py-32" style={{ backgroundColor: '#f5f5f5' }}>
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        {/* Section label */}
        <div className="flex items-center gap-4 mb-16">
          <span className="font-sans text-terracotta text-[11px] tracking-[0.4em] uppercase">06</span>
          <div className="flex-1 h-px bg-warm-border" />
          <span className="font-sans text-warm-muted text-[11px] tracking-[0.3em]">Team</span>
        </div>

        {/* Heading */}
        <div
          ref={headRef}
          className={`mb-16 transition-all duration-900 ${headVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <h2 className="font-serif text-charcoal text-2xl md:text-3xl lg:text-4xl leading-loose">
            一緒に働く人
          </h2>
        </div>

        {/* Members grid */}
        <div
          ref={gridRef}
          className={`grid grid-cols-1 sm:grid-cols-3 gap-10 md:gap-14 transition-all duration-1000 delay-100 ${gridVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          {members.map((m, i) => (
            <div
              key={m.name}
              className="flex flex-col items-center text-center"
              style={{ transitionDelay: `${i * 120}ms` }}
            >
              {/* Avatar */}
              <div
                className="w-32 h-32 md:w-40 md:h-40 rounded-full overflow-hidden border border-gray-200 flex-shrink-0 mb-5"
              >
                <img
                  src={m.image}
                  alt={m.name}
                  className={`w-full h-full object-cover object-top ${m.mono ? 'grayscale' : ''}`}
                />
              </div>

              {/* Name */}
              <p className="font-sans font-bold text-charcoal text-base md:text-lg tracking-wide mb-1">
                {m.name}
              </p>

              {/* Role */}
              {m.role && (
                <p className="font-sans text-terracotta text-xs tracking-widest uppercase mb-3">
                  {m.role}
                </p>
              )}

              {/* Description */}
              <p className="font-sans text-warm-muted text-xs md:text-sm leading-relaxed max-w-[240px]">
                {m.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
